module.exports = __webpack_public_path__ + "img/layout4.6a16981b.png";